<div class="page-wrapper">
  <section class="grey">
    <div class="content-wrapper">
      <section class="login-page">
        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <h2>Login with email</h2>
          <div
            class="form-errors"
            *ngIf="
              !loginNotFound &&
              (authService.logoutReason === 401 ||
                authService.logoutReason === 419)
            "
          >
            <p class="form-error" *ngIf="authService.logoutReason === 401">
              Session Expired. Please login
            </p>
            <p class="form-error" *ngIf="authService.logoutReason === 419">
              Session Expired. Please login
            </p>
          </div>
          <div class="form-errors" *ngIf="loginNotFound">
            <p
              class="form-error"
              *ngIf="notAdminError; else loginNotFoundError"
            >
              You do not have permission to access this site
            </p>
            <ng-template #loginNotFoundError>
              <p class="form-error">
                We didn't recognise those details. Please check and try again
              </p>
            </ng-template>
          </div>
          <div class="login-fields">
            <div class="form-field">
              <input
                type="email"
                id="email"
                class="email"
                formControlName="email"
                placeholder="Email Address"
              />
            </div>
            <div class="form-field">
              <input
                type="password"
                id="password"
                class="password"
                formControlName="password"
                placeholder="Password"
              />
            </div>
          </div>
          <button
            class="button"
            type="submit"
            [class.button-loading]="loggingIn"
          >
            <span>Login</span>
          </button>
        </form>
      </section>
    </div>
  </section>
</div>
